import { render } from "./StarModal.vue?vue&type=template&id=0cf15b77&scoped=true"
import script from "./StarModal.vue?vue&type=script&lang=js"
export * from "./StarModal.vue?vue&type=script&lang=js"

import "./StarModal.vue?vue&type=style&index=0&id=0cf15b77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf15b77"]])

export default __exports__